module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-event-item linked-item"
  }, [_c('div', {
    staticClass: "contact-event-icon",
    class: _vm.iconClass()
  }), _c('div', {
    staticClass: "contact-event-header"
  }, [(_vm.event.humanStatus()) ? _c('div', {
    staticClass: "contact-event-title"
  }, [_vm._v(_vm._s(_vm.event.title + " - " + _vm.event.humanStatus()))]) : _c('div', {
    staticClass: "contact-event-title"
  }, [_vm._v(_vm._s(_vm.event.title))]), (_vm.event.quotedDescription()) ? _c('div', {
    staticClass: "contact-event-description"
  }, [_vm._v(_vm._s(_vm.event.quotedDescription()))]) : _vm._e(), (_vm.event.flow.name) ? _c('div', {
    staticClass: "contact-event-description"
  }, [_c('div', {
    staticClass: "contact-event-title"
  }, [_vm._v("do ")]), _vm._v(" Fluxo " + _vm._s(_vm.event.flow.name))]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "contact-event-time"
  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), (_vm.event.email) ? _c('span', {
    staticClass: "glyphicon glyphicon-eye-open showEmail",
    on: {
      "click": function($event) {
        _vm.event.showEmail = !_vm.event.showEmail
      }
    }
  }) : _vm._e(), (_vm.event.showEmail) ? _c('div', {
    staticClass: "contact-event-email"
  }, [(_vm.canResendEmail()) ? _c('div', {
    staticClass: "contact-event-email-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_value),
      expression: "email_value"
    }],
    staticClass: "form-control pull-left",
    domProps: {
      "value": (_vm.email_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email_value = $event.target.value
      }
    }
  }), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "resendEmail"
    },
    on: {
      "click": function($event) {
        return _vm.resendEmail(_vm.event)
      }
    }
  }, [_vm._v("Reenviar")])]) : _vm._e(), (_vm.event.email.html) ? _c('div', {
    staticClass: "contact-event-email-body",
    domProps: {
      "innerHTML": _vm._s(_vm.remove_opening_register_pixel(_vm.event.email.html))
    }
  }) : (_vm.event.email.text) ? _c('div', {
    staticClass: "contact-event-email-body"
  }, [_vm._v(_vm._s(_vm.remove_opening_register_pixel(_vm.event.email.text)))]) : _vm._e()]) : _vm._e(), (_vm.event.call_recording_url) ? _c('div', {
    staticClass: "audio-wrapper pull-right"
  }, [_c('audio', {
    attrs: {
      "controls": "controls"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.event.call_recording_url,
      "type": "audio/mpeg"
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0c004a0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/events/event.vue
// module id = 1207
// module chunks = 1